export * from './array-helper'
export * from './menu-route-helper'
export * from './dom-helper'
export * from './storage-helper'

import Util from './types/utils';
export const $util=new Util();